import React from 'react'

export default props => (
  <header className='tc flex flex-column justify-center items-center'>
    <h2 className='norms-36 fw5 dark-gray ma0'>{props.children}</h2>
    <div className='w3 mt2 bg-mid-gray'
      style={{
        height: '0.125rem',
        marginBottom: '2.5rem',
      }}
    />
  </header>
)
